import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress page — permanently redirect to the real blog post.
export const Route = createFileRoute("/baldness-gene")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/baldness-gene-come-mother-father/", location.searchStr), statusCode: 301 });
  },
});
